import React from "react";
import { AgentName } from "../../config/config";

const Hero = () => {
  const formattedAgentName = AgentName.charAt(0).toUpperCase() + AgentName.slice(1);

  return (
    <section className="w-full py-24 md:py-32 text-center text-gray-900 container mx-auto">
      <div className="container px-4 md:px-6">
        {/* Hero Section */}
        <div className="heroHeaders">
          {/* Main Heading optimized for SEO */}
          <h1 className="text-2xl md:text-4xl font-bold tracking-tight text-gray-800 mb-6">
          Discover the Best <strong>{formattedAgentName} Spreadsheet</strong>
          </h1>
        
        <h2 className="text-base md:text-2xl font-semibold tracking-tight text-gray-700 mb-4">
          More than 7,000 <strong>{formattedAgentName}</strong> links
        </h2>

          {/* Description Text optimized for SEO */}
          <p className="text-xs sm:text-lg md:text-xl text-gray-700 leading-relaxed px-4 md:px-0 max-w-2xl mx-auto mb-8">
            I've been collecting over 7000+ <strong>{formattedAgentName} finds</strong> with prices listed in USD.
            the <strong>{formattedAgentName} spreadsheets</strong> offers the latest <strong>deals</strong> Make sure to <strong>bookmark this page</strong> for weekly updates on the best finds. 
            Don't forget to use "Ctrl+D" to add this <strong>spreadsheet</strong> to your bookmarks list.
          </p>

          {/* Call to Action */}
          <div className="flex justify-center">
            <a
              href="/products"
              className="btn6 text-base sm:text-base px-4 sm:px-8 py-3 rounded-md text-white transition-all hover:bg-slate-800 hover:text-white"
            >
              Browse {formattedAgentName} Products
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default React.memo(Hero);
